import { CustomTextField } from '../../../../../components/CustomTextField';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const StepSetUp = ({ disabled, emptyFields, handleChange, errorCode, errorName, item }) => {
    return (
         <div className='row'>
            <CustomTextField
                id='txt_ssp_name'
                name='name'
                value={item?.name}
                trans='name'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorName}
                isValidText='the_value_already_exists'
                required={true}
                length={64}
            />
            <CustomTextField
                id='txt_ssp_id'
                name='code'
                 value={item?.code}
                trans='code'
                type={'text'}
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorCode}
                isValidText='the_value_already_exists'
                required={true}
                length={16}
            />
            <CustomTextField
                id='txt_ssp_description'
                name='description'
                value={item?.description}
                trans='description'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                required={true}
                multiline={true}
                length={512}
            />
        </div>
    );
};

export default StepSetUp;
